import React from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const Navigation = (props) => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);

    return <NavigationItem links={contentLinks} favoritePageUrl={props.favoritePageUrl} hideSearch={props.hideSearch} showPriceWithVAT={props.showPriceWithVAT} />;
};

export default Navigation;
